// extracted by mini-css-extract-plugin
export default {"cardd":"ep_cardd__Yjjde","btnn":"ep_btnn__7sJi7","t":"ep_t__c+KEG","s":"ep_s__hV6NO","c":"ep_c__udUDd","icon":"ep_icon__oGBBR"};